module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_NO 02.f0f4fa7c.svg";